import { IBusinessShoppingCenterSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { IState } from '../../../store';

export function businessShoppingCenterSelector(state: IState): IBusinessShoppingCenterSchema | null {
  return state.offerData.businessShoppingCenter;
}
